import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=6204a84a&scoped=true&"
import script from "./Services.vue?vue&type=script&lang=js&"
export * from "./Services.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=6204a84a&scoped=true&lang=css&"
import style1 from "./Services.vue?vue&type=style&index=1&id=6204a84a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6204a84a",
  null
  
)

export default component.exports